import { render, staticRenderFns } from "./BoardMemberTable.vue?vue&type=template&id=c44db41a&scoped=true&"
import script from "./BoardMemberTable.vue?vue&type=script&lang=js&"
export * from "./BoardMemberTable.vue?vue&type=script&lang=js&"
import style0 from "./BoardMemberTable.vue?vue&type=style&index=0&id=c44db41a&scoped=scss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44db41a",
  null
  
)

export default component.exports